import { string, func } from 'prop-types';
import { useCallback } from 'react';

import { Button } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

import { useModalContext } from 'hb-builder/hooks';

const EditImageSource = ({ hasImage, id, onModalOpen }) => {
  const { setModalOpen } = useModalContext();

  const buttonText = hasImage
    ? s__('Builder|Edit image')
    : s__('Builder|Choose image');

  const handleClick = useCallback(() => {
    setModalOpen((prevIsModalOpen) => ({
      ...prevIsModalOpen,
      [id]: true,
    }));
    onModalOpen?.();
  }, [id, onModalOpen, setModalOpen]);

  return (
    <Button
      fontFamily="Inter"
      mb="10px"
      onClick={handleClick}
      variant="secondary"
      width="100%"
      icon={() => (
        <FontAwesomeIcon
          height="16px"
          iconType={CATEGORIES.SOLID}
          iconName="image"
        />
      )}
    >
      {buttonText}
    </Button>
  );
};

export default EditImageSource;

EditImageSource.propTypes = {
  id: string.isRequired,
  onModalOpen: func,
};
